export default __webpack_public_path__ + "static/media/Vue.bf7006b0.png";